// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"i8-z"};